export default "__VITE_ASSET__DPw2UYDg__"